import { getQlikResources } from "./getQlikResources";
import { store } from "../store/store";
import { getQlikApp } from "./qlikService";
import { generateUUID, generateRandomString } from '../utils/stringGenerator';
import { EXPORT } from "../constants/exportData";
import { showSnackbar } from "../store/slice/snackbarSlice";
import { QLIK_APP_REF, THEME } from "../constants";
import { CYBER_CONFIG } from "../constants/cyberConfig";

const dispatch = store.dispatch;

//Export data funtion using Qlik Reports APIs
export async function exportData(name: string, exportType:string = "image"): Promise<any> {
    try {
        if (!name) return null;
    
        const config = await getQlikResources("qlik-servers");
        const appConfig = await getQlikResources("qlik-apps");
        const appDef = appConfig[QLIK_APP_REF];
        const serverDef: any = config[appDef?.serverRef];
        const { host, port, secure, prefix } = serverDef;
        const qlikServerPrefix = prefix !== "" ? `/${prefix}` : "";
        const qlikServerPath = `${(secure ? "https://" : "http://") + host + (port ? `:${port}` : "") + qlikServerPrefix}`;
        const vizConfig = await getQlikResources("qlik-visualizations")
        const vizDef = vizConfig[name];
        const qlikApp = await getQlikApp(vizDef.appRef);
        //Getting visualization object
        const viz = await qlikApp.getObject(vizDef.id);
    
        let vizId = "";
        //Container viz
        if (viz.genericType === "sn-tabbed-container") {
            const vizContainerLayout = await viz.getLayout();
            //Getting active tab object id
            const activeTab = vizContainerLayout.objects.find((child:any) => child.condition === -1);
            vizId = vizContainerLayout.qChildList.qItems.find((item:any) => activeTab?.childRefId === item.qData.childRefId).qInfo.qId;
    
        }
        //Normal viz
        else {
            vizId = vizDef.id;
        }

        //Reading viz layout, data and legendData
        const vizLayout = await viz.getLayout();
        const vizLegendSize = {
            "qHeight": 100,
            "qLeft": 0,
            "qTop": 0,
            "qWidth": 2
        }
        const vizLegendData = vizLayout.qHyperCube.qDimensionInfo[0].qAttrDimInfo.lenght ? await viz.getHyperCubeData('/qHyperCubeDef/qDimensions/0/qAttributeDimensions/0',[vizLegendSize]) : [];
        const qlikAppLocaleInfo = await qlikApp.getLocaleInfo();

        //Reading ColorMapModel if present
        const colorMapModelObj = vizLayout.qHyperCube.qDimensionInfo[0]?.coloring?.colorMapRef ? await qlikApp.getObject(`ColorMapModel_${vizLayout.qHyperCube.qDimensionInfo[0].coloring.colorMapRef}`) : null;
        const colorMapModelLayout = colorMapModelObj ? await colorMapModelObj.getLayout() : {};

        //Defining snapshpot data
        const width = 750;
        const height = 500;
        const snapshotDataChild = {
            "object": {
                "size": {
                    "w": width, //width of chart on the screen
                    "h": height, //height of chart on the screen
                // "boundingClientWidth": 441.5, // can try to not pass it
                // "boundingClientHeight": 378 // can try to not pass it
                }
            },
            "rtl": false,	// pass it always as false
            "content": {
                "size": {
                    "w": width,
                    "h": height
                },
                "chartData": {
                    "rotation": vizLayout.visualization == 'piechart' ? 0 : "",                    "scrollOffset": {
                        "start": vizLayout.scrollStartPos,  //Scroll start position in getLayout
                        "end": 3
                    },
                    // "legendScrollOffset": vizLayout.scrollStartPos,
                    // "legendDataPage": [vizLegendData],  //getHyperCubeData: /qHyperCubeDef/qDimensions/0/qAttributeDimensions/0
                    "dimValsData": colorMapModelLayout?.colorMap
                }
            },
            "parent": {         //try to not pass it
                // "h": 822,
                // "w": 909
            }
        };

        //Creating final snapshot data 
        let snapshotDataInput: any = {};
        let snapshotDataParent = vizLayout;
        snapshotDataParent.qInfo.qId = generateRandomString(10); //Need to use code for generating random string

        //Adding snapshotdata child
        snapshotDataParent["snapshotData"] = snapshotDataChild;
        //Adding reduced hypercube
        snapshotDataParent["reducedHyperCube"] = {
            "qDataPages": vizLayout.qHyperCube.qDataPages,
            "qDimensionInfo": vizLayout.qHyperCube.qDimensionInfo,
            "qEffectiveInterColumnSortOrder": vizLayout.qHyperCube.qEffectiveInterColumnSortOrder,
            "qMeasureInfo": vizLayout.qHyperCube.qMeasureInfo,
            "qStackedDataPages": vizLayout.qHyperCube.qStackedDataPages,
            "qMode": vizLayout.qHyperCube.qMode,
            "qSize": vizLayout.qHyperCube.qSize,
            "qColumnOrder": []
        };
        snapshotDataParent["visualizationType"] = vizLayout.visualization;
        snapshotDataParent["sourceObjectId"] = vizId;
        // snapshotDataParent["sheetId"] = vizDef.sheetRef; //try to not pass it
        snapshotDataParent["timestamp"] = new Date().getTime();
        // snapshotDataParent["isClone"] = false; //try to not pass it
        // snapshotDataParent["qMetaDef"] = {"title":""}; //try to not pass it
        snapshotDataParent["supportExport"] = true;

        //Adding above info to final input
        snapshotDataInput["data"] = snapshotDataParent;

        //Adding locale info
        snapshotDataInput["appLocaleInfo"] = qlikAppLocaleInfo;
        snapshotDataInput["language"] = "en-US";

        //Keep snapshot data as object - will be stringified only once when sending to API


        //Create snapshot

        let reportSettings = {};
        switch(exportType) {
            case 'image':
                // ===========================================================
                // ========================== Image ==========================
                // ===========================================================
    
    
                //Report APIs for exporting chart as image
                reportSettings = {
                    "imageType": "Png",
                    "captureSize": {
                        "width": width,
                        "height": height,
                        "dpi": 96
                    },
                    "objTree": {
                        "id": vizId,
                        "type": vizLayout.visualization,
                        "snapshotData": JSON.stringify(snapshotDataInput),
                        "area": {
                            "left": 0,
                            "top": 0,
                            "width": 1,
                            "height": 1
                        },
                        "children": [],
                        "isExtension": false,
                        "title": "Global Incident Growth Compared to 2012*"
                    },
                    // "appName": "Cyber Index V3 - UI - With data",
                    "appId": appDef.appId,
                    "appStylingInfo": {
                        "sheetLogoPosition": "",
                        "sheetLogoThumbnail": {
                            "qStaticContentUrl": {}
                        },
                        "sheetTitleBgColor": "",
                        "sheetTitleColor": "",
                        "sheetTitleGradientColor": "",
                        "rtl": false
                    },
                    "localeInfo": qlikAppLocaleInfo,
                    "themeName": THEME
                }
            break;
        }

        
        //Generate Report
        const requestId = generateUUID();
        const report = await fetch(`${qlikServerPath}/printing/export/object/image?requestId=${requestId}`, { 
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reportSettings)
        });
        
        //Check Report APIs status end point for understanding when report is ready to be downloaded
        return await checkReportStatus(requestId, qlikServerPath);
    }
    catch (error) {
        console.error("General error exporting data:", error);
        dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.generalErrorMessage }));
        return null;
    }    
  
}

async function checkReportStatus(reportId: string, qlikServerPath: string): Promise<string | null> {
    // let attempts = 0;
    const pollingInterval = EXPORT.pollingInterval;

    // while (attempts < retryCounter) {
    return new Promise((resolve) => {
   
        const poll = async () => {
            try {
                const reportStatusRequest = await fetch(`${qlikServerPath}/printing/export/request/status?requestId=${reportId}`, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (reportStatusRequest.status !== 200) {
                    throw new Error(`Failed to fetch report status: ${reportStatusRequest.status}`);
                }

                const reportStatus = await reportStatusRequest.json() as any;

                // Check if the report is ready
                if (reportStatus.status === "Completed") {
                    const tempContentUrl = reportStatus.qUrl.replace(/^\.\./, '');
                    
                    // const tempContentId = tempContentMatch ? tempContentMatch[1] : null;
                    // const inlineMatch = reportStatus.results[0].location.match(/[?&]inline=([^&]+)/);
                    // const inlineValue = inlineMatch ? inlineMatch[1] : null;
                    
                    // Fetch the report
                    const report:any = await fetch(`${qlikServerPath}${tempContentUrl}`, {
                        method: 'GET',
                        credentials: 'include'
                    });

                    if (!report.ok) {
                        // store.dispatch(showSnackbar({reason: "exportError", message: i18n.t('message.export.maxRetriesError')}));
                        throw new Error(`Failed to download report: ${report.status}`);
                    }

                    return resolve(report); // Return the blob
                }

                setTimeout(poll, pollingInterval);

            // console.log(`Report status: ${reportStatus.status}. Retrying in ${pollingInterval / 1000} seconds...`);
            } catch (error) {
                console.error(`Error while checking report status: ${error}`);
                dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.generalErrorMessage }));
                return resolve(null);
            }

            // Wait for the polling interval before the next attempt
            // await new Promise((resolve) => setTimeout(resolve, pollingInterval));
            // attempts++;
        }

        poll();
    })

}

export default {
    exportData
};
